export class Firm {
    constructor(
            public id: number = null,
            public firm_id: number = null,
            public firm: string = null,
            public territory_id: number = null,
            public territory: string = null,
            public name: string = null) { }
}



// WEBPACK FOOTER //
// /usr/home/rob/Staxi/client/src/app/_classes/list/firm.ts